import { cacheDom } from "../utils/QuerySelectors.js"
import { setCartOpen } from '../apps/store/cartSlice'
import store from '../apps/store/store'
import { getSearchResults } from '../utils/PredictiveSearch.js'

const dom = {}
const qs = {
  mobileBtn: 'data-mobile-btn',
  cartBtn: 'data-cart-open',
  searchBtn: 'data-search-open',
  searchContainer: 'data-search-drawer',
  searchModal: 'data-search-modal',
  searchContent: 'data-search-content',
  searchInput: 'data-search-input',
  searchClose: 'data-search-close',
}
const qsAll = {
  cartBtns: 'data-cart-open',
}
const keyThreshold = 500

const searchString = (e) => {
  clearTimeout(window.keyTimer)
  window.keyTimer = setTimeout(() => {
    if(e.target.value.length != 0) {
      getSearchResults((response) => {
        dom.searchContent.innerHTML = new DOMParser().parseFromString(response, 'text/html').getElementById('predictive-search-results').innerHTML
      }, e.target.value)
    }
  }, keyThreshold)
}

const searchOpen = (open) => {
  dom.searchContainer.classList.toggle('z-[-1]', !open)
  dom.searchContainer.classList.toggle('opacity-0', !open)
  dom.searchContainer.classList.toggle('z-50', open)
  dom.searchContainer.classList.toggle('opacity-100', open)
  document.body.classList.toggle('overflow-hidden', open)
  if(open) dom.searchInput.focus()
}

export const setupHeader = () => {
  cacheDom(dom, qs, qsAll)
  dom.mobileBtn.addEventListener('click', () => document.body.classList.toggle('mobile-nav-open'))
  dom.cartBtns.forEach((cartBtn) => {
    cartBtn.addEventListener('click', (e) => {
      e.preventDefault()
      store.dispatch(setCartOpen(true))
    })
  })
  dom.searchBtn.addEventListener('click', () => searchOpen(true))
  dom.searchClose.addEventListener('click', () => searchOpen(false))
  dom.searchInput.addEventListener('keyup', (e) => searchString(e))
  dom.searchContainer.addEventListener('click', () => searchOpen(false))
  dom.searchModal.addEventListener('click', (e) => e.stopPropagation())
}